import React from "react"
import classes from "./AddRemoveButton.module.css"
import CustomIconButton from "../../atoms/IconButton/CustomIconButton"
import classNames from "classnames"

type ButtonVariant = "outlined" | "outlinedBottom" | "contained"

export interface AddRemoveButton {
  value: number
  min?: number
  max?: number
  onChange?: (value: number) => void
  variant: ButtonVariant
  iconSize?: number
}

const AddRemoveButton = ({
  value,
  min,
  max,
  onChange,
  variant,
  iconSize,
}: AddRemoveButton) => {
  const decreaseQuantity = () => {
    if (!min || value > min) {
      onChange?.(value - 1)
    }
  }

  const increaseQuantity = () => {
    if (!max || value < max) {
      onChange?.(value + 1)
    }
  }

  const maxDisabled = () => Boolean(max && value >= max)
  const minDisabled = () => Boolean(min && value <= min)

  return (
    <div
      style={{
        ["--icon-size" as any]: `${iconSize ?? 20}px`,
      }}
      className={classNames(classes.root, {
        [classes.outlined]: variant === "outlined",
        [classes.outlinedBottom]: variant === "outlinedBottom",
      })}
    >
      <CustomIconButton
        icon={
          <span
            className={classNames(classes.icon, classes.remove, {
              [classes.iconDisabled]: minDisabled(),
            })}
          >
            -
          </span>
        }
        disabled={minDisabled()}
        onClick={decreaseQuantity}
        className={classes.icon}
      />
      <div className={classes.item}>{value}</div>
      <CustomIconButton
        icon={
          <span
            className={classNames(classes.icon, classes.add, {
              [classes.iconDisabled]: maxDisabled(),
            })}
          >
            +
          </span>
        }
        disabled={maxDisabled()}
        onClick={increaseQuantity}
      />
    </div>
  )
}

export default AddRemoveButton
